import { Bounce, Flip, Slide, toast } from "react-toastify";
import { Tooltip } from "react-tooltip";
import React from "react";
import uuid from "react-uuid";

export const alertType = {
  Error: "error",
  Warning: "warning",
  Info: "info",
  Success: "success",
};

export const e3 = {
  ToastOptions: {
    position: "top-center",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    transition: Flip,
    toastId: "1",
  },
  toast: {
    Error: (id = e3.ToastOptions.toastId, message) => {
      toast.error(message, {
        position: e3.ToastOptions.position,
        autoClose: e3.ToastOptions.autoClose,
        hideProgressBar: e3.ToastOptions.hideProgressBar,
        closeOnClick: e3.ToastOptions.closeOnClick,
        pauseOnHover: e3.ToastOptions.pauseOnHover,
        draggable: e3.ToastOptions.draggable,
        progress: e3.ToastOptions.progress,
        transition: e3.ToastOptions.transition,
        toastId: id,
      });
    },
    Warning: (id = e3.ToastOptions.toastId, message) => {
      toast.warning(message, {
        position: e3.ToastOptions.position,
        autoClose: e3.ToastOptions.autoClose,
        hideProgressBar: e3.ToastOptions.hideProgressBar,
        closeOnClick: e3.ToastOptions.closeOnClick,
        pauseOnHover: e3.ToastOptions.pauseOnHover,
        draggable: e3.ToastOptions.draggable,
        progress: e3.ToastOptions.progress,
        transition: e3.ToastOptions.transition,
        toastId: id,
      });
    },
    Success: (id = e3.ToastOptions.toastId, message) => {
      toast.success(message, {
        position: e3.ToastOptions.position,
        autoClose: e3.ToastOptions.autoClose,
        hideProgressBar: e3.ToastOptions.hideProgressBar,
        closeOnClick: e3.ToastOptions.closeOnClick,
        pauseOnHover: e3.ToastOptions.pauseOnHover,
        draggable: e3.ToastOptions.draggable,
        progress: e3.ToastOptions.progress,
        transition: e3.ToastOptions.transition,
        toastId: id,
      });
    },
    Info: (id = e3.ToastOptions.toastId, message) => {
      toast.info(message, {
        position: e3.ToastOptions.position,
        autoClose: e3.ToastOptions.autoClose,
        hideProgressBar: e3.ToastOptions.hideProgressBar,
        closeOnClick: e3.ToastOptions.closeOnClick,
        pauseOnHover: e3.ToastOptions.pauseOnHover,
        draggable: e3.ToastOptions.draggable,
        progress: e3.ToastOptions.progress,
        transition: e3.ToastOptions.transition,
        toastId: id,
      });
    },
    loading: (id = e3.ToastOptions.toastId) => {
      let loadMsg = e3.getLoadMsg(id);
      return toast.loading(loadMsg, {
        position: e3.ToastOptions.position,
        transition: e3.ToastOptions.transition,
        toastId: id,
        hideProgressBar: true,
      });
    },
    closeLoading: (id = null) => {
      toast.dismiss(id);
    },
    finishLoading: (id = e3.ToastOptions.toastId, type = "success") => {
      let renderMsg = e3.getRenderMsg(id, type);
      return toast.update(id, {
        render: renderMsg,
        position: e3.ToastOptions.position,
        type: type,
        isLoading: false,
        autoClose: e3.ToastOptions.autoClose,
        pauseOnFocusLoss: false,
        transition: e3.ToastOptions.transition,
        toastId: id,
        className: "rotateY animated",
      });
    },
    isActive: (id) => {
      return toast.isActive(id);
    },
  },
  getRenderMsg: (id, type) => {
    const renderMsg = {
      success: {
        SAVE: "저장이 완료되었습니다.",
        DEL: "삭제가 완료되었습니다.",
        DEFAULT: "조회가 완료되었습니다.",
      },
      error: {
        SAVE: "저장에 실패하였습니다.",
        DEL: "삭제를 실패하였습니다.",
        DEFAULT: "오류가 발생하였습니다.",
      },
      warning: {
        SAVE: "저장에 실패하였습니다.",
        DEL: "삭제를 실패하였습니다.",
        DEFAULT: "검색결과가 없습니다",
      },
    };
    const upperId = id?.toUpperCase() || "DEFAULT";
    return renderMsg[type]?.[upperId] || renderMsg[type]?.DEFAULT;
  },

  getLoadMsg: (id) => {
    const loadMsg = {
      SAVE: "저장 중입니다",
      DEL: "삭제 중입니다",
      DEFAULT: "조회 중입니다",
    };

    const upperId = id?.toUpperCase() || "DEFAULT";
    return loadMsg[upperId] || loadMsg.DEFAULT;
  },
  getUUID: () => {
    return uuid();
  },
  convertFileToBinaryString: async (file) => {
    if (!file) {
      return null;
    }

    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => {
        resolve(reader.result);
      };

      reader.readAsDataURL(file);
      reader.onerror = reject;
    });

    // const fileBinaryString = await e3.readFileAsync(file);
    // return fileBinaryString;
  },
  readFileAsync: (file) => {
    if (!file) {
      return null;
    }

    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => {
        resolve(reader.result);
      };

      reader.readAsDataURL(file);
      reader.onerror = reject;
    });
  },
  /**
   *
   * @param {string | number} text
   * @returns {void}
   */
  copyTextToClipboard: (text) => {
    // textare 생성
    const _element = document.createElement("textarea");

    // value 입력
    _element.value = text.toString();

    // 안보이게
    _element.style.position = "fixed";
    _element.style.opacity = 0;

    // document 에 추가
    document.body.appendChild(_element);

    // 선택
    _element.select();

    // 복사
    document.execCommand("copy");

    // 삭제
    document.body.removeChild(_element);
  },
};
